<template>
    <pt-skeleton :loading="true" :class="[$style.container, props.size && $style[props.size]]">
        <template #template>
            <div :class="$style.banner"></div>
            <section :class="$style.section">
                <ul v-for="i in 5" :key="i">
                    <li v-for="j in 2" :key="j">
                        <pt-skeleton-item style="background: #ebecf0" variant="text" />
                    </li>
                </ul>
            </section>
            <div :class="$style.banner2"></div>
            <section :class="$style.section2" v-for="x in 2" :key="x">
                <ul v-for="i in 3" :key="i">
                    <li v-for="j in 5" :key="j">
                        <pt-skeleton-item style="background: #ebecf0" variant="text" />
                    </li>
                </ul>
            </section>
        </template>
        ></pt-skeleton
    >
</template>

<script lang="ts">
export default {
    name: 'PhoneSkeleton',
    components: {}
};
</script>
<script lang="ts" setup>
import { computed, ref, watch } from 'vue';

interface Props {
    size?: string;
}
const props = defineProps<Props>();
</script>

<style lang="scss" module>
.container {
    overflow: hidden;
    .banner {
        height: 195px;
        background: #dfe1e6;
    }
    .banner2 {
        margin-top: 20px;
        height: 100px;
        background: #dfe1e6;
    }
    section {
        ul > li > div {
            height: 12px;
        }
        ul > li:nth-of-type(5) > div {
            width: 50%;
        }
    }
    .section {
        margin-top: 20px;
        padding: 0 10px;
        display: grid;
        grid-template-columns: 48px 48px 48px 48px 48px;
        gap: 0px 20px;

        ul > li:first-child > div {
            width: 48px;
            height: 48px;
            border-radius: 100%;
        }
    }
    .section2 {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        display: grid;
        grid-template-columns: 100px 100px 100px;
        gap: 0px 18px;

        ul > li:first-child > div {
            width: 100px;
            height: 100px;
        }
    }
    &.small {
        .banner {
            height: 141px;
        }
        .banner2 {
            margin-top: 12px;
            height: 60px;
        }
        section {
            ul > li > div {
                height: 6px;
            }
        }
        .section {
            margin-top: 12px;
            grid-template-columns: 30px 30px 30px 30px 30px;
            ul > li:first-child > div {
                width: 30px;
                height: 30px;
                border-radius: 100%;
            }
        }
        .section2 {
            margin-top: 12px;
            grid-template-columns: 60px 60px 60px;
            ul > li:first-child > div {
                width: 60px;
                height: 60px;
            }
        }
    }
}
</style>
